import React, { useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";
import "./TrialQuizzesPage.css";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import Header from "../../../components/Header/Header";
import QuizCard from "../../../components/QuizComponents/Cards/QuizCard/QuizCard";
import ActivateAccountAlert from "../../../components/Auth/ActivateAccountAlert/ActivateAccountAlert";

const navLinks = [
];

function TrialQuizzesPage() {
    const [quizzes, setQuizzes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const axiosInstance = useAxios();
    const [isActivateAlertOpen, setIsActivateAlertOpen] = useState(false);

    useEffect(() => {
        const fetchQuizzes = async () => {
            try {
                const response = await axiosInstance.get('/quizzes/owner');
                if (response.data.success) {
                    setQuizzes(response.data.quizzes);
                } else {
                    setError(response.data.message || "Failed to fetch quizzes.");
                }
            } catch (err) {
                setError(err.response?.data?.message || "An unexpected error occurred.");
            } finally {
                setLoading(false);
            }
        };

        fetchQuizzes();
    }, []);

    const handleEditQuiz = (quizId) => {
        setIsActivateAlertOpen(true);
    };

    const handleDeleteQuiz = (quizId) => {
        setIsActivateAlertOpen(true);
    };

    let content;

    if (loading) {
        content = (
            <Box className="loading-container">
                <CircularProgress />
                <Typography variant="h6" className="loading-text">
                    Fetching Quizzes...
                </Typography>
            </Box>
        );
    } else if (error) {
        content = (
            <Box className="error-container">
                <Typography variant="h6" color="error">
                    {error}
                </Typography>
            </Box>
        );
    } else {
        content = (
            <div className="quizzes-grid">
                {quizzes.map((quiz) => (
                    <QuizCard
                        key={quiz.id}
                        quiz={quiz}
                        onEditClick={() => handleEditQuiz(quiz.id)}
                        onDeleteClick={() => handleDeleteQuiz(quiz.id)}
                    />
                ))}
            </div>
        );
    }

    return (
        <>
            <Header navLinks={navLinks} isScrollEffect={false} />
            <Container className="owner-quizzes-container page-container">
                <Typography variant="h4" className="page-title">
                    Your Trial Quizzes
                </Typography>
                {content}
                <ActivateAccountAlert open={isActivateAlertOpen} onClose={() => setIsActivateAlertOpen(false)} />

            </Container>
        </>
    );
}

export default TrialQuizzesPage;
